var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('PProgressCircular',{staticClass:"loader",attrs:{"indeterminate":""}}),_c('h4',{staticClass:"text"},[_vm._v("Sistema em atualização. Aguarde.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }